export enum RepairKitStatus {
  VALID = 'VALID',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  EMPTY = 'EMPTY',
  MISSING = 'MISSING',
}